// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/services/user_service.proto (package kikoff_canada.protobuf.services, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Error } from "../types/error_pb.js";
import { User } from "../models/user_pb.js";
import { Locale } from "../types/locale_pb.js";

/**
 * @generated from message kikoff_canada.protobuf.services.BootstrapResponse
 */
export class BootstrapResponse extends Message<BootstrapResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.User user = 2;
   */
  user?: User;

  /**
   * @generated from field: google.protobuf.Timestamp server_time = 3;
   */
  serverTime?: Timestamp;

  /**
   * @generated from field: bool impersonating = 4;
   */
  impersonating = false;

  constructor(data?: PartialMessage<BootstrapResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.BootstrapResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user", kind: "message", T: User },
    { no: 3, name: "server_time", kind: "message", T: Timestamp },
    { no: 4, name: "impersonating", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BootstrapResponse {
    return new BootstrapResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BootstrapResponse {
    return new BootstrapResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BootstrapResponse {
    return new BootstrapResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BootstrapResponse | PlainMessage<BootstrapResponse> | undefined, b: BootstrapResponse | PlainMessage<BootstrapResponse> | undefined): boolean {
    return proto3.util.equals(BootstrapResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ShowUserResponse
 */
export class ShowUserResponse extends Message<ShowUserResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.User user = 2;
   */
  user?: User;

  constructor(data?: PartialMessage<ShowUserResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ShowUserResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user", kind: "message", T: User },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShowUserResponse {
    return new ShowUserResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShowUserResponse {
    return new ShowUserResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShowUserResponse {
    return new ShowUserResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ShowUserResponse | PlainMessage<ShowUserResponse> | undefined, b: ShowUserResponse | PlainMessage<ShowUserResponse> | undefined): boolean {
    return proto3.util.equals(ShowUserResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ConfirmEmailRequest
 */
export class ConfirmEmailRequest extends Message<ConfirmEmailRequest> {
  /**
   * @generated from field: string confirmation_token = 1;
   */
  confirmationToken = "";

  constructor(data?: PartialMessage<ConfirmEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ConfirmEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "confirmation_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmEmailRequest {
    return new ConfirmEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmEmailRequest {
    return new ConfirmEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmEmailRequest {
    return new ConfirmEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmEmailRequest | PlainMessage<ConfirmEmailRequest> | undefined, b: ConfirmEmailRequest | PlainMessage<ConfirmEmailRequest> | undefined): boolean {
    return proto3.util.equals(ConfirmEmailRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ConfirmEmailResponse
 */
export class ConfirmEmailResponse extends Message<ConfirmEmailResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  constructor(data?: PartialMessage<ConfirmEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ConfirmEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConfirmEmailResponse {
    return new ConfirmEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConfirmEmailResponse {
    return new ConfirmEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConfirmEmailResponse {
    return new ConfirmEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ConfirmEmailResponse | PlainMessage<ConfirmEmailResponse> | undefined, b: ConfirmEmailResponse | PlainMessage<ConfirmEmailResponse> | undefined): boolean {
    return proto3.util.equals(ConfirmEmailResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.SendConfirmationEmailResponse
 */
export class SendConfirmationEmailResponse extends Message<SendConfirmationEmailResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  constructor(data?: PartialMessage<SendConfirmationEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.SendConfirmationEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SendConfirmationEmailResponse {
    return new SendConfirmationEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SendConfirmationEmailResponse {
    return new SendConfirmationEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SendConfirmationEmailResponse {
    return new SendConfirmationEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SendConfirmationEmailResponse | PlainMessage<SendConfirmationEmailResponse> | undefined, b: SendConfirmationEmailResponse | PlainMessage<SendConfirmationEmailResponse> | undefined): boolean {
    return proto3.util.equals(SendConfirmationEmailResponse, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ChangeLocaleRequest
 */
export class ChangeLocaleRequest extends Message<ChangeLocaleRequest> {
  /**
   * @generated from field: kikoff_canada.protobuf.types.Locale locale = 1;
   */
  locale = Locale.UNKNOWN;

  constructor(data?: PartialMessage<ChangeLocaleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeLocaleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locale", kind: "enum", T: proto3.getEnumType(Locale) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeLocaleRequest {
    return new ChangeLocaleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeLocaleRequest {
    return new ChangeLocaleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeLocaleRequest {
    return new ChangeLocaleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeLocaleRequest | PlainMessage<ChangeLocaleRequest> | undefined, b: ChangeLocaleRequest | PlainMessage<ChangeLocaleRequest> | undefined): boolean {
    return proto3.util.equals(ChangeLocaleRequest, a, b);
  }

  static _enums: {
  };
}

/**
 * @generated from message kikoff_canada.protobuf.services.ChangeLocaleResponse
 */
export class ChangeLocaleResponse extends Message<ChangeLocaleResponse> {
  /**
   * @generated from field: repeated kikoff_canada.protobuf.types.Error errors = 1;
   */
  errors: Error[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.User user = 2;
   */
  user?: User;

  constructor(data?: PartialMessage<ChangeLocaleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.services.ChangeLocaleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: Error, repeated: true },
    { no: 2, name: "user", kind: "message", T: User },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeLocaleResponse {
    return new ChangeLocaleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeLocaleResponse {
    return new ChangeLocaleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeLocaleResponse {
    return new ChangeLocaleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeLocaleResponse | PlainMessage<ChangeLocaleResponse> | undefined, b: ChangeLocaleResponse | PlainMessage<ChangeLocaleResponse> | undefined): boolean {
    return proto3.util.equals(ChangeLocaleResponse, a, b);
  }

  static _enums: {
  };
}

